import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import LeafBackground from './components/LeafBackground';

// Import Pages
import Home from './pages/Home';
import Beskaeftigelsen from './pages/Beskaeftigelsen';
import Section103 from './pages/Section103';
import Maalgruppe from './pages/Maalgruppe';
import Aktivitetstilbud from './pages/Aktivitetstilbud';
import Vaerdigrundlag from './pages/Vaerdigrundlag';
import Paedagogik from './pages/Paedagogik';
import STU from './pages/STU';
import GalleryPage from './pages/GalleryPage';
import Contact from './pages/Contact';
import LocalEsbjerg from './pages/LocalEsbjerg';
import LocalVejen from './pages/LocalVejen';
import LocalKolding from './pages/LocalKolding';

function App() {
  return (
    <>
      {/* Scroll restoration on route change */}
      <ScrollToTop />
      
      <div className="flex flex-col min-h-screen bg-stone-50 text-stone-800 selection:bg-emerald-100 selection:text-emerald-900 relative">
        {/* Animated Leaf Background */}
        <LeafBackground />

        {/* Navigation Bar */}
        <Navbar />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/beskaeftigelsen" element={<Beskaeftigelsen />} />
            <Route path="/paragraf-103" element={<Section103 />} />
            <Route path="/section-103" element={<Section103 />} />
            <Route path="/maalgruppe" element={<Maalgruppe />} />
            <Route path="/aktivitetstilbud" element={<Aktivitetstilbud />} />
            <Route path="/vaerdigrundlag" element={<Vaerdigrundlag />} />
            <Route path="/paedagogik" element={<Paedagogik />} />
            <Route path="/stu" element={<STU />} />
            <Route path="/billeder" element={<GalleryPage />} />
            <Route path="/kontakt" element={<Contact />} />
            
            {/* Lokale landingssider */}
            <Route path="/beskyttet-beskaeftigelse-esbjerg" element={<LocalEsbjerg />} />
            <Route path="/beskyttet-beskaeftigelse-naer-esbjerg" element={<LocalEsbjerg />} />
            
            <Route path="/beskyttet-beskaeftigelse-vejen" element={<LocalVejen />} />
            <Route path="/beskyttet-beskaeftigelse-naer-vejen" element={<LocalVejen />} />
            
            <Route path="/beskyttet-beskaeftigelse-kolding" element={<LocalKolding />} />
            <Route path="/beskyttet-beskaeftigelse-naer-kolding" element={<LocalKolding />} />
            
            {/* Fallback route */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}

export default App;
